export default __webpack_public_path__ + "static/media/customer-service.bc22b33c.png";